<template>
  <flex-column :class="{ has: hasSelection }">
    <div class="padder" v-if="loading">
      <spinner />
    </div>
    <template v-else>
      <flex-column>
        <flex-header v-show="allLeaves.length > 20">
          <div class="padder">
            <flex-row gap center>
              <flex-cell>
                <search v-model="keywords" placeholder="Search scopes"
              /></flex-cell>
              <flex-cell shrink>
                <ux-button @click="expandAll" size="xs">Expand All</ux-button>
              </flex-cell>
              <flex-cell shrink>
                <ux-button @click="collapseAll" size="xs"
                  >Collapse All</ux-button
                >
              </flex-cell>
            </flex-row>
          </div>
        </flex-header>
        <flex-body class="scroll-body">
          <div class="padder">
            <scope-item
              :click="click"
              :keywords="keywords"
              :item="scope"
              v-for="scope in filteredScopes"
            />
          </div>
        </flex-body>
      </flex-column>
    </template>
  </flex-column>
</template>
<script>
import ScopeItem from "./ScopeItem.vue";
import Search from "../form/inputs/Search.vue";
let inflight;

export default {
  components: {
    ScopeItem,
    Search,
  },
  created() {
    this.$glossary.ensure();
  },
  props: {
    action: {
      type: String,
    },
    type: {
      type: String,
      required: true,
    },
    include: {
      type: String,
      default: "scope",
    },
    modelValue: {
      type: Array,
      default() {
        return [];
      },
    },
    single: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,

      model: this.modelValue,
      scopes: [],
      registry: {},
      keywords: "",
    };
  },
  mounted() {},
  beforeUnmount() {},
  methods: {
    expandAll() {
      const self = this;
      self.allLeaves.forEach(function ({ _id }) {
        self.registry[_id] = false;
      });
    },
    collapseAll() {
      const self = this;
      self.allLeaves.forEach(function ({ _id }) {
        self.registry[_id] = true;
      });
    },

    select(scope) {
      if (this.single) {
        this.model = [scope];
        return;
      }

      if (!this.isSelected(scope)) {
        this.model.push(scope);
      }
    },
    deselect(scope) {
      const self = this;
      const scopeID = self.$sdk.utils.id(scope);

      if (self.isSelected(scope)) {
        if (self.single) {
          self.model.length = 0;
        }

        self.model = self.model.filter(function (entry) {
          const entryID = self.$sdk.utils.id(entry);
          return entryID != scopeID;
        });
      }
    },
    isSelected(scope) {
      const scopeID = this.$sdk.utils.id(scope);
      return this.hash[scopeID];
    },
    toggle(scope) {
      if (this.isSelected(scope)) {
        this.deselect(scope);
      } else {
        this.select(scope);
      }
    },
    click(scope) {
      this.toggle(scope);
    },
    async checkLoad() {
      if (inflight) {
        return;
      }

      inflight = true;
      if (this.action && this.type) {
        this.scopes = await this.loadScopes();
      } else {
        console.log("missing action or type", this.action, this.type);
        this.scopes = await this.loadTree();
      }

      inflight = false;
    },
    async loadTree() {
      this.loading = true;
      const { data } = await this.$sdk.api.get(`/scope/tree`);
      this.loading = false;
      return data;
    },
    async loadScopes() {
      this.loading = true;
      const { data } = await this.$sdk.api.post(`/scope/actionable`, {
        action: this.action,
        type: this.type,
      });
      this.loading = false;
      return data;
    },
    async showModal() {
      const self = this;
      const options = {};

      const component = await self.$sdk.modal({
        component: ScopeSelectModal,
        options,
      });
    },
  },
  provide() {
    return {
      isSelected: this.isSelected,
      registry: this.registry,
    };
  },
  computed: {
    glossary() {
      return this.$glossary.hash;
    },
    filteredScopes() {
      let array = this.scopes;

      const include = this.field?.include || this.include || "scope";

      switch (include) {
        case "unit":
          array = array.filter(function (scope) {
            return !!scope.unit;
          });
          break;
        case "scope":
          array = array.filter(function (scope) {
            return !scope.unit;
          });
          break;
      }
      return array;
    },
    hasSelection() {
      return this.model.length;
    },
    hash() {
      return this.model.reduce(function (memo, scope) {
        memo[scope._id || scope] = true;
        return memo;
      }, {});
    },
    empty() {
      return !this.model.length;
    },
    summary() {
      const self = this;

      if (!self.model.length) {
        return "Select Scopes";
      }

      return self.model
        .map(function (scope) {
          return scope.title;
        })
        .join(", ");
    },

    allLeaves() {
      const accumulator = [];

      function walk(tree) {
        tree.forEach(function (item) {
          accumulator.push(item);

          if (item.children) {
            walk(item.children);
          }
        });
      }

      walk(this.filteredScopes);

      return accumulator;
    },
  },
  watch: {
    type: {
      handler() {
        this.checkLoad();
      },
      immediate: true,
    },
    action: {
      handler() {
        this.checkLoad();
      },
      immediate: true,
    },
    modelValue(m) {
      this.model = m;
    },
    model(m) {
      this.$emit("update:modelValue", m);
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-body {
  background: rgba(#000, 0.1);
}

.padder {
  padding: 1em;
}

:deep(.ux-btn-text) {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 150px;
  display: block;
}

.has :deep(.scope-item) {
  opacity: 0.7;
  background: color-mix(in lab, currentColor 5%, transparent);
}
:deep(.scope-item.selected) {
  opacity: 1;
  background: var(--bg1, #fff);
  border-color: var(--primary);
}

.empty-text {
  opacity: 0.5;
}
</style>
